import { cn } from "@/lib/utils";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ButtonPrime({ url, icon, text, className, onClick, children }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (url) navigate(url);
  };

  return (
    <div>
      <button
        onClick={handleClick}
        className={cn(
          "flex h-[3.5rem] w-fit   items-center gap-2 px-4 py-2 bg-prime-700 group text-white font-medium font-sans rounded-md hover:bg-prime-800  transition-all",
          className
        )}
      >
        <div className="flex items-center justify-start w-full gap-2">
          {icon ?           <div className="w-[3rem] h-full self-start">{icon}</div> : null
}
          <div className="w-full">{text}{children}</div>
        </div>
      </button>
    </div>
  );
}
